import { Button } from '@opendoor/atoms/button';

import { FooterForegroundBox } from './FooterForegroundBox';

const FooterHelpCenter = ({ helpCenterLink }: { helpCenterLink: string }) => {
  return (
    <FooterForegroundBox title="Still have questions?">
      <Button
        href={helpCenterLink}
        aria-label="Opendoor Help Center button"
        analyticsName="cosmos-landing-page-v2-footer-help-center"
        variant="secondaryInverse"
        size="sm"
      >
        Visit the Help Center
      </Button>
    </FooterForegroundBox>
  );
};

export default FooterHelpCenter;
